// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.adx_log[data-v-1a8cd098] {\n  min-width: 1920px;\n}\n.floater_table__body div .success_circle[data-v-1a8cd098] {\n  height: 10px;\n}\n.floater_table__body div .active_circle[data-v-1a8cd098] {\n  height: 10px;\n}\n.floater_table__body div .secondary_circle[data-v-1a8cd098] {\n  height: 10px;\n}\n.floater_table[data-v-1a8cd098] {\n  max-width: initial;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
